import { observableWrapper } from './observable';
export var getInitState = function (opts) { return function (defaultState) {
    if (!defaultState) {
        throw new Error('Trying to initialize state without default state.');
    }
    return {
        state: observableWrapper(defaultState, opts),
    };
}; };
//# sourceMappingURL=index.js.map